<template>
	<div class="list-wrapper">
		<!-- List -->
		<ul v-if="!isLoading">
			<slot name="top"></slot>
			<li v-for="(item, i) in list" :key="i" :class="itemClasses">
				<slot name="list" :item="item"></slot>
			</li>
			<slot></slot>
		</ul>

		<!-- Loading spinner -->
		<div v-if="isLoading" class="p4">
			<j-spinner size="small" />
		</div>

		<!--Empty state message -->
		<div class="empty" v-if="list.length === 0 && isLoading === false">
			<slot name="empty"></slot>
		</div>
	</div>
</template>

<script>
import JSpinner from "@/components/JSpinner/"

export default {
	name: "j-list",
	components: { JSpinner },
	props: {
		isLoading: {
			type: Boolean,
			default: false
		},
		list: {
			type: Array,
			required: true,
			default: () => []
		},
		itemClasses: {
			type: String,
			required: false,
			default: "bc7 bb1"
		}
	}
}
</script>

<style scoped>
@import "../../assets/css/tokens.css";

.list-wrapper {
	width: 100%;
}

.list-wrapper > ul {
	display: block;
	width: 100%;
	list-style-type: none;
}

.list-wrapper > ul > li {
	display: flex;
	align-items: center;
	width: 100%;
	min-height: 40px;
	font-size: var(--fontSize3);
}

.list-wrapper > ul > li:hover {
	background-color: var(--color4);
}

.list-wrapper > ul > li:last-child {
	border: 0;
}

.list-wrapper > ul > li > * {
	height: 100%;
}
</style>
